import { FunctionComponent, memo } from "react";
import { Group } from "../../group";
import { Icon } from "../../icon";
import { Paper } from "../../paper";
import { Text } from "../../text";
import styles from "./changelog-card.module.scss";
import { IProps } from "./changelog-card.types";

/**
 * A bordered card with a labelled, icon'd header and a body. A building block for
 * grouped changelog entries (e.g. the contact-reason changelog) where one timeline item
 * holds several change cards.
 * @param props.label - Header label.
 * @param props.icon - Header icon.
 * @param props.children - Card body.
 */
const ChangelogCardComponent: FunctionComponent<IProps> = ({ label, icon, children }) => (
    <Paper p="sm" radius="md" withBorder rootStackGap="xs">
        <Group justify="space-between" align="center">
            <Text size="sm" dimmed>
                {label}
            </Text>
            <Icon icon={icon} size="xs" className={styles["icon"]} />
        </Group>
        {children}
    </Paper>
);

const ChangelogCard = memo(ChangelogCardComponent);

export { ChangelogCard };
